import { isArray, isObject, without } from 'lodash';

function getArray(arr) {
  return isArray(arr) ? arr : [];
}

export function addToArray(arr, el) {
  return getArray(arr).concat(el);
}

export function removeFromArray(arr, el) {
  if (!isArray(arr)) {
    return arr;
  }
  return without(arr, el);
}

export function toggleInArray(arr, el) {
  const existingArray = getArray(arr);
  if (existingArray.includes(el)) {
    return removeFromArray(existingArray, el);
  }
  return addToArray(existingArray, el);
}

function getObject(obj) {
  return isObject(obj) ? obj : {};
}

export function addToObject(obj, name, value) {
  const existingObj = getObject(obj);
  return { ...existingObj, [name]: value };
}

export function removeFromObject(obj, name) {
  const existingObj = getObject(obj);
  return Object.keys(existingObj).reduce((o, key) => {
    if (key !== name) {
      return { ...o, [key]: obj[key] };
    }
    return o;
  }, {});
}

export function isObjectEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ../core/src/utils/immutable.js